export default "6ea3fe96331195d4.png"